
import Group from './group.vue';
import VirtualList from 'vue-virtual-scroll-list'

export default {

    components: {
        Group,
        VirtualList
    },

    props: {
        group: {
            type: Object,
            default: null,
        },
        employee: {
            type: Object,
            default: null,
        }
    },

    created() {
        let t = this;
        t.dict.lang = listToDict(t.list.lang);
        if (window.timerRefreshMsg) {
            clearInterval(window.timerRefreshMsg);
            window.timerRefreshMsg = null;
        }
        if (localStorage['chatLang' + t.U.id]) {
            t.translator.lang = localStorage['chatLang' + t.U.id];
        }
        t.loadData();
        if (t.group) {
            t.loadGroupMembers();
        }
    },

    activated() {
        let t = this;
    },

    beforeDestroy() {
        if (window.timerRefreshMsg) {
            clearInterval(window.timerRefreshMsg);
            window.timerRefreshMsg = null;
        }
    },

    methods: {

        onSelect(action) {
            let t = this;

            if (action.id == 1) {
                t.takePicture();
            }
            else {
                t.uploadPicture();
            }
        },

        loadGroupMembers() {
            let t = this;

            axios.post('im/getGroupMembers/' + t.group.id).then(res => {
                if (res.data.status == 1) {
                    let items = res.data.options.members;
                    items.forEach(item => {
                        item.name = item.lastname + item.firstname;
                    });
                    t.list.member = items;
                }
            });
        },

        onMsgListScroll() {
            let t = this;

            if (t.$refs.msgList.scrollTop <= 100 && t.hasMoreHistory) {

                if (t.locking) {
                    return;
                }

                t.lastScrollTop = t.$refs.msgList.scrollTop;
                t.lastScrollHeight = t.$refs.msgList.scrollHeight;
                t.locking = true;
                setTimeout(() => {
                    t.locking = false;
                }, 2000);
                t.loadData(true);
            }

        },

        handleInput(char) {

            let t = this;

            if (!t.group) {
                return;
            }

            if (this.dontShowOnce) {
                this.dontShowOnce = false;
                return;
            }

            const input = this.$refs.msgBox.$el;
            const value = input.value;
            const cursorPosition = input.selectionStart;

            if (cursorPosition > 0) {

                if (value.charAt(cursorPosition - 1) === '@') {

                    event.preventDefault();

                    this.showAtList = true;

                    this.lastPosition = cursorPosition;
                }
            }
        },

        closeAtList() {
            this.showAtList = false;
        },

        atAll() {
            let t = this;
            const input = this.$refs.msgBox.$el;
            const value = input.value;
            let insertText = 'All ';

            const before = value.substring(0, t.lastPosition - 1); // 排除 @
            const after = value.substring(t.lastPosition);

            const newText = before + '@' + insertText + after;

            this.f.text = newText;

            this.showAtList = false;

            this.dontShowOnce = true;

            this.$nextTick(() => {
                input.focus();
                const newCursorPos = before.length + 1 + insertText.length; // @张三 | 的位置
                input.setSelectionRange(newCursorPos, newCursorPos);
            });

            this.list.member.forEach(member => {
                this.f.refEmployees[member.id] = member.name;
            });
        },

        atMember(item) {
            let t = this;
            const input = this.$refs.msgBox.$el;
            const value = input.value;
            let insertText = item.name + ' ';

            const before = value.substring(0, t.lastPosition - 1); // 排除 @
            const after = value.substring(t.lastPosition);

            const newText = before + '@' + insertText + after;
            this.f.text = newText;
            this.showAtList = false;
            this.dontShowOnce = true;

            this.$nextTick(() => {
                input.focus();
                const newCursorPos = before.length + 1 + insertText.length; // @张三 | 的位置
                input.setSelectionRange(newCursorPos, newCursorPos);
            });

            this.f.refEmployees[item.id] = item.name;

        },

        back() {
            this.$emit('back');
        },

        toHTML(item) {
            item.source_text = item.text;
            if (item.ref_employee_data) {
                let refEmployeeData = JSON.parse(item.ref_employee_data);
                item.refEmployeeData = refEmployeeData;
                for (const id in refEmployeeData) {
                    let name = refEmployeeData[id];
                    item.text = item.text.replace('@' + name, '<i>@' + name + '</i>');
                    if (item.text_en)
                        item.text_en = item.text_en.replace('@' + name, '<i>@' + name + '</i>');
                    if (item.text_jp)
                        item.text_jp = item.text_jp.replace('@' + name, '<i>@' + name + '</i>');
                    if (item.text_cn)
                        item.text_cn = item.text_cn.replace('@' + name, '<i>@' + name + '</i>');
                }
                let name = 'All';
                item.text = item.text.replace('@' + name, '<i>@' + name + '</i>');
                if (item.text_en)
                    item.text_en = item.text_en.replace('@' + name, '<i>@' + name + '</i>');
                if (item.text_jp)
                    item.text_jp = item.text_jp.replace('@' + name, '<i>@' + name + '</i>');
                if (item.text_cn)
                    item.text_cn = item.text_cn.replace('@' + name, '<i>@' + name + '</i>');
            }
        },

        loadData(history) {

            let t = this;

            let f = {
                '_lastId': null,
                '_minId': null
            };

            if (t.busying)
                return;

            t.busying = true;

            if (t.group) {
                f.group_id = t.group.id;

                t.showNotice = true;

                if (t.group.notice_read_employee_ids) {
                    let arr = t.group.notice_read_employee_ids.split(',');
                    if (arr.indexOf(t.U.id.toString()) > -1) {
                        t.showNotice = false;
                    }
                }
            }

            if (t.employee) {
                f.other_id = t.employee.id;
            }

            if (history) {
                f._minId = t.list.msg[0].id;
            }
            else if (t.list.msg.length > 0) {
                f._lastId = t.list.msg[t.list.msg.length - 1].id;
            }

            axios.get('chatMsg', { params: f }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {

                    let items = res.data.options.items;

                    if (items.length > 0) {

                        items.forEach(item => {
                            item.dateLine = null;
                            item.status = 1;
                            item.translating = false;
                            item.time_text = t.friendlyTime(item.created_at, t.translator.lang);
                            if (item.type == 2) {
                                item.imgs = item.imgs.split(',');
                            }
                            if (item.ref && item.ref.type == 2) {
                                item.ref.imgs = item.ref.imgs.split(',');
                            }
                        });

                        if (!history) {
                            for (let i = items.length - 1; i >= 0; i--) {
                                let item = items[i];
                                t.pushMsg(item);
                            }
                        }
                        else {
                            for (let i = 0; i < items.length; i++) {
                                // for (let i = items.length - 1; i >= 0; i--) {
                                let item = items[i];
                                t.pushMsg(item, true);
                            }
                        }

                        let limit = 10;

                        t.hasMoreHistory = items.length >= limit;

                        if (t.translator.lang != 'none') {

                            if (items.length >= limit) {

                                for (let i = 1; i <= limit; i++) {

                                    let item = items[items.length - i];

                                    if (item.type == 1 &&
                                        item.employee_id != t.U.id &&
                                        !item['text_' + t.translator.lang]) {
                                        let text = item.source_text;

                                        if (item.refEmployeeData) {
                                            for (const id in item.refEmployeeData) {
                                                let name = item.refEmployeeData[id];
                                                text = text.replace('@' + name);
                                            }
                                        }

                                        text = text.trim();

                                        if (text)
                                            t.translate(item);
                                    }
                                }
                            }
                            else {

                                items.forEach(item => {
                                    if (item.type == 1 &&
                                        item.employee_id != t.U.id &&
                                        !item['text_' + t.translator.lang]) {
                                        let text = item.source_text;

                                        if (item.refEmployeeData) {
                                            for (const id in item.refEmployeeData) {
                                                let name = item.refEmployeeData[id];
                                                text = text.replace('@' + name);
                                            }
                                        }

                                        text = text.trim();

                                        if (text)
                                            t.translate(item);
                                    }
                                });
                            }
                        }

                        t.showMsgList = true;

                        if (!history) {
                            t.$nextTick(() => {
                                if (t.$refs.msgList)
                                    t.$refs.msgList.scrollTop = t.$refs.msgList.scrollHeight;
                            });
                        }
                        else {
                            t.$nextTick(() => {
                                if (t.$refs.msgList)
                                    t.$refs.msgList.scrollTop = t.$refs.msgList.scrollHeight - t.lastScrollHeight + t.lastScrollTop;
                            });

                        }
                    }
                    else {
                        if (history) {
                            t.hasMoreHistory = false;
                        }
                    }

                    if (!history) {
                        t.initDateLines();
                    }

                    if (!window.timerRefreshMsg) {
                        window.timerRefreshMsg = setInterval(() => {
                            t.loadData();
                        }, 2000);
                    }
                }

            }).catch(res => {
                t.busying = false;
            });

        },

        initDateLines() {
            let t = this;
            let dict = {};
            let today = (new Date()).format('yyyy/MM/dd');

            t.list.msg.forEach(item => {
                let date = (new Date(item.created_at)).format('yyyy/MM/dd');
                if (!dict[date]) {
                    dict[date] = true;
                    item.dateLine = {
                        text: date,
                        is_today: date == today
                    };
                }
            });
        },

        pushMsg(item, first) {
            let t = this;

            t.toHTML(item);

            if (!t.dict.msg[item.id]) {
                if (first) {
                    t.list.msg.unshift(item);
                }
                else {
                    t.list.msg.push(item);
                }
                t.dict.msg[item.id] = item;
            }
        },

        saveLang() {
            localStorage['chatLang' + this.U.id] = this.translator.lang;
        },

        translate(item, manual) {

            let t = this;

            if (item.translating) {
                return;
            }

            item.translating = true;

            let p = {};

            if (manual) {
                p.redo = 1;
            }

            axios.post('chatMsg/translate/' + item.id + '/' + t.translator.lang, p).then(res => {
                if (res.data.status == 1) {

                    let text = res.data.options.translated;

                    item.translating = false;

                    if (item.refEmployeeData) {
                        for (const id in item.refEmployeeData) {
                            let name = item.refEmployeeData[id];
                            text = text.replace('@' + name, '<i>@' + name + '</i>');
                        }
                    }

                    item['text_' + t.translator.lang] = text;
                }
            });
        },

        showPicture(imgs, idx) {

            let t = this;

            if (t.dontShowPreview) {
                t.dontShowPreview = false;
                return;
            }

            let imgUrls = [];

            imgs.forEach(img => {
                imgUrls.push(t.url(img));
            });

            t.previewImages = imgUrls;
            t.showPreview = true;
            t.previewIndex = idx;

            // ImagePreview({
            //     images: imgUrls,
            //     startPosition: idx,
            //     closeable: true,
            //     showIndicators: true,
            // });
        },

        async downloadPicture(idx) {
            let t = this;

            let imgUrl = t.previewImages[idx];

            if (window.Capacitor && Capacitor.Plugins.Media) {

                let grant = await Capacitor.Plugins.Filesystem.requestPermissions();
                if (grant.publicStorage != 'granted') {
                    A.err('エラーが発生しました。');
                    return;
                }

                if (Capacitor.getPlatform().toLowerCase() == 'ios') {
                    let opts = { path: 'https://' + imgUrl, albumIdentifier: albums[0].identifier };
                    await Capacitor.Plugins.Media.savePhoto(opts);
                    A.toast('画像を保存しました');
                }
                else if (Capacitor.getPlatform().toLowerCase() == 'android') {
                    await Capacitor.Plugins.Media.createAlbum({ 'name': 'kis' }).catch(err => console.log(err));
                    let albums = await Capacitor.Plugins.Media.getAlbums();
                    albums = albums.albums.filter(item => item.name == 'kis');
                    if (albums.length == 0) {
                        A.err('エラーが発生しました。');
                        return;
                    }
                    else {
                        let opts = { path: 'https://' + imgUrl, albumIdentifier: albums[0].identifier };
                        await Capacitor.Plugins.Media.savePhoto(opts);
                        A.toast('画像を保存しました');
                    }
                }

            }
            else {
                let a = document.createElement('a');
                a.target = '_blank';
                a.href = imgUrl;
                a.click();
            }
        },

        refEmployee(item) {
            let t = this;

            // let employee = item.employee;

            // t.f.refEmployees[employee.id] = employee.name;

            // if (t.f.text.indexOf('@' + employee.name) > -1) {

            // }
            // else {
            //     t.f.text += '@' + employee.name + ' ';
            // }

            // t.$refs.msgBox.focus();

        },

        refMsg(item) {
            let t = this;

            t.dontShowPreview = true;

            t.ref = item;

            t.$forceUpdate();
        },

        async uploadPicture() {
            let t = this;

            if (window.Capacitor && Capacitor.Plugins.Camera) {

                async function filePathToBlob(filePath) {
                    let res = await Capacitor.Plugins.Filesystem.readFile({
                        path: filePath
                    });

                    const binaryString = atob(res.data);

                    const len = binaryString.length;
                    const bytes = new Uint8Array(len);
                    for (let i = 0; i < len; i++) {
                        bytes[i] = binaryString.charCodeAt(i);
                    }

                    const blob = new Blob([bytes], { type: 'image/jpeg' });

                    const blobUrl = URL.createObjectURL(blob);

                    return [blob, blobUrl];
                }

                let grant = await Capacitor.Plugins.Camera.requestPermissions('photos');

                if (grant.photos != 'granted') {
                    A.err('Photos permission not granted');
                    return;
                }


                let res = await Capacitor.Plugins.Camera.pickImages({
                    quality: 70,
                    limit: 15
                });
                if (res && res.photos.length > 0) {

                    if (res.photos.length > 9) {
                        A.err('No more than 9 images can be selected at a time');
                        return;
                    }

                    let imgs = [];
                    let queue = [];

                    for (let i = 0; i < res.photos.length; i++) {
                        const item = res.photos[i];
                        let res2 = await filePathToBlob(item.path);
                        let blob = res2[0];
                        let url = res2[1];

                        imgs.push(url);

                        queue.push({
                            blob: blob,
                            url: url,
                            progress: 0,
                            uploading: false
                        });
                    }

                    if (queue.length > 0) {
                        let msgItem = t.sendPictures(imgs);
                        let uploadTask = {
                            queue: queue,
                            msgItem: msgItem,
                            imgs: []
                        };
                        t.uploadTasks.push(uploadTask);
                        t.startUpload(uploadTask, true);
                    }

                }
            }
            else {
                ImageUploader.onSelectImage = null;
                ImageUploader.onSelectImages = (files) => {

                    if (files.length > 9) {
                        A.err('No more than 9 images can be selected at a time');
                        return;
                    }

                    let imgs = [];
                    let queue = [];
                    for (let i = 0; i < files.length; i++) {
                        let url = URL.createObjectURL(files[i]);
                        queue.push({
                            blob: files[i],
                            url: url,
                            progress: 0,
                            uploading: false
                        });
                        imgs.push(url);
                    }

                    if (queue.length > 0) {
                        // t.uploading = true;
                        let msgItem = t.sendPictures(imgs);
                        let uploadTask = {
                            queue: queue,
                            msgItem: msgItem,
                            imgs: []
                        };
                        t.uploadTasks.push(uploadTask);
                        t.startUpload(uploadTask);
                    }

                };

                ImageUploader.openSelector(true);
            }

        },

        async takePicture() {

            let t = this;

            if (window.Capacitor && Capacitor.Plugins.Camera) {

                let logError = console.error;

                console.error = (err) => {
                    A.err(err.toString());
                }

                async function filePathToBlob(filePath) {
                    let res = await Capacitor.Plugins.Filesystem.readFile({
                        path: filePath
                    });
                    return base64ToBlob(res.data)
                }

                function base64ToBlob(base64) {
                    const binaryString = atob(base64);

                    const len = binaryString.length;
                    const bytes = new Uint8Array(len);
                    for (let i = 0; i < len; i++) {
                        bytes[i] = binaryString.charCodeAt(i);
                    }

                    const blob = new Blob([bytes], { type: 'image/jpeg' });

                    const blobUrl = URL.createObjectURL(blob);

                    return [blob, blobUrl];
                }

                let grant = await Capacitor.Plugins.Camera.requestPermissions('camera');

                if (grant.camera != 'granted') {
                    A.err('Camera permission not granted');
                    return;
                }

                let res = await Capacitor.Plugins.Camera.getPhoto({
                    quality: 70,
                    source: 'CAMERA',
                    resultType: 'Uri',
                });

                if (res) {

                    let imgs = [];
                    let queue = [];

                    if (res.path) {

                        const item = res;
                        let res2 = await filePathToBlob(item.path);
                        let blob = res2[0];
                        let url = res2[1];

                        imgs.push(url);

                        queue.push({
                            blob: blob,
                            url: url,
                            progress: 0,
                            uploading: false
                        });
                   
                    }

                    else if (res.base64String) {
                        let res3 = await base64ToBlob(res.base64String);
                        let blob = res3[0];
                        let url = res3[1];

                        imgs.push(url);

                        queue.push({
                            blob: blob,
                            url: url,
                            progress: 0,
                            uploading: false
                        });
                    }

                    if (queue.length > 0) {
                            let msgItem = t.sendPictures(imgs);
                            let uploadTask = {
                                queue: queue,
                                msgItem: msgItem,
                                imgs: []
                            };
                            t.uploadTasks.push(uploadTask);
                            t.startUpload(uploadTask);
                        }
                }

                console.error = logError;
            }
            else {
                ImageUploader.onSelectImages = null;
                ImageUploader.onSelectImage = (file) => {

                    if (file) {
                        let imgs = [];

                        let queue = [];
                        for (let i = 0; i < files.length; i++) {
                            let url = URL.createObjectURL(files[i]);
                            queue.push({
                                blob: files[i],
                                url: url,
                                progress: 0,
                                uploading: false
                            });
                            imgs.push(url);
                        }

                        if (queue.length > 0) {
                            // t.uploading = true;
                            let msgItem = t.sendPictures(imgs);
                            let uploadTask = {
                                queue: queue,
                                msgItem: msgItem,
                                imgs: []
                            };
                            t.uploadTasks.push(uploadTask);
                            t.startUpload(uploadTask);
                        }

                    }
                };

                ImageUploader.openCamera();
            }

        },

        sendPictures(imgs) {
            let t = this;

            let msgItem = {
                created_at: (new Date()).format('yyyy-MM-dd hh:mm:ss'),
                time_text: t.friendlyTime((new Date()).format('yyyy-MM-dd hh:mm:ss'), t.translator.lang),
                translating: false,
                employee: t.U,
                employee_id: t.U.id,
                text_cn: '',
                text_en: '',
                text_jp: '',
                type: 2,
                ref: null,
                receiver_id: t.employee ? t.employee.id : null,
                group_id: t.group ? t.group.id : null,
                status: 0,
            };

            msgItem.imgs = imgs;

            t.pushMsg(msgItem);

            t.$nextTick(() => {
                if (t.$refs.msgList)
                    t.$refs.msgList.scrollTop = t.$refs.msgList.scrollHeight;
            });

            return msgItem;
        },

        async startUpload(uploadTask) {

            let t = this;

            for (let i = 0; i < uploadTask.queue.length; i++) {

                const uploadTaskItem = uploadTask.queue[i];

                let fd = new FormData();

                let blob = await compressImageBlob(uploadTaskItem.blob);

                fd.append('image', blob);

                let res = await axios.post('chatMsg/saveImage', fd, { headers: { 'Content-Type': 'multipart/form-data' } });

                if (res.data.status == 1) {
                    let imgUrl = res.data.options.img_url;
                    uploadTask.imgs.push(imgUrl);
                }
            }

            let form = {
                imgs: uploadTask.imgs.join(','),
            };

            if (t.group) {
                axios.post('chatMsg/sendToGroup/' + t.group.id + '/' + 2, form).then(res => {
                    if (res.data.status == 1) {
                        uploadTask.msgItem.id = res.data.options.item.id;
                        uploadTask.msgItem.status = 1;
                    }
                    else if (res.data.status == 2) {
                        A.err('あなたはこのグループから退出しました。');
                        t.$emit('group-change');
                        t.back();
                    }
                });

            } else if (t.employee) {
                axios.post('chatMsg/sendToEmployee/' + t.employee.id + '/' + 2, form).then(res => {
                    if (res.data.status == 1) {
                        uploadTask.msgItem.id = res.data.options.item.id;
                        uploadTask.msgItem.status = 1;
                    }
                });
            }


        },

        goRef(item) {

            let t = this;

            let msgItem = document.querySelector('#msg' + item.id);

            if (!msgItem) {
                return;
            }

            msgItem.scrollIntoView({
                behavior: 'smooth', // 平滑滚动（可选）
                block: 'nearest',   // 对齐方式
                inline: 'nearest'
            });

            // if (item.type == 2) {
            //     t.showPicture(item.imgs, 0);
            // }
            // else if(item.type == 1){
            // }


        },

        sendMsg() {
            let t = this;

            if (!t.f.text) {
                // t.$refs.msgBox.$el.focus();
                return;
            }

            let form = { text: t.f.text };

            if (t.ref)
                form.ref_id = t.ref.id;

            let hasRef = false;
            let dict = {};

            for (const id in t.f.refEmployees) {
                let name = t.f.refEmployees[id];
                if (t.f.text.indexOf('@' + name) > -1) {
                    dict[id] = name;
                    hasRef = true;
                }
            }

            if (hasRef) {
                form.ref_employee_data = JSON.stringify(dict);
            }

            function afterSend(item) {
                if (item.ref && item.ref.type == 2) {
                    item.ref.imgs = item.ref.imgs.split(',');
                }
                mirror(item, msgItem);
                t.dict.msg[item.id] = msgItem;
                msgItem.status = 1;

            }

            let msgItem = {
                text: t.f.text,
                time_text: t.friendlyTime((new Date()).format('yyyy-MM-dd hh:mm:ss'), t.translator.lang),
                ref_employee_data: form.ref_employee_data,
                ref_id: form.ref_id,
                translating: false,
                employee: t.U,
                employee_id: t.U.id,
                text_cn: '',
                text_en: '',
                text_jp: '',
                type: 1,
                ref: null,
                receiver_id: t.employee ? t.employee.id : null,
                group_id: t.group ? t.group.id : null,
                status: 0,
            };

            t.toHTML(msgItem);

            t.list.msg.push(msgItem);

            msgItem = t.list.msg[t.list.msg.length - 1];

            t.f.refEmployees = {};
            t.f.text = '';
            t.ref = null;

            t.$nextTick(() => {
                if (t.$refs.msgList)
                    t.$refs.msgList.scrollTop = t.$refs.msgList.scrollHeight;
            });

            const instance = axios.create({
                timeout: 3000
            });

            if (t.group) {
                instance.post('chatMsg/sendToGroup/' + t.group.id + '/' + 1, form).then(res => {
                    if (res.data.status == 1) {
                        let item = res.data.options.item;
                        afterSend(item);
                    }
                    else if (res.data.status == 2) {
                        A.err('あなたはこのグループから退出しました。');
                        t.$emit('group-change');
                        t.back();
                    }
                }).catch(err => {
                    msgItem.status = 2;
                });
            }
            else if (t.employee) {
                instance.post('chatMsg/sendToEmployee/' + t.employee.id + '/' + 1, form).then(res => {
                    if (res.data.status == 1) {
                        let item = res.data.options.item;
                        afterSend(item);
                    }
                }).catch(err => {
                    msgItem.status = 2;
                });
            }

            t.showMsgList = true;

        },

        resendMsg(msgItem) {
            let t = this;

            msgItem.status = 0;

            function afterSend(item) {
                if (item.ref && item.ref.type == 2) {
                    item.ref.imgs = item.ref.imgs.split(',');
                }
                mirror(item, msgItem);
                t.dict.msg[item.id] = msgItem;
                msgItem.status = 1;
            }

            const instance = axios.create({
                timeout: 3000
            });

            let form = getFields(msgItem, ['text', 'ref_id', 'ref_employee_data']);

            if (t.group) {
                instance.post('chatMsg/sendToGroup/' + t.group.id + '/' + 1, form).then(res => {
                    if (res.data.status == 1) {
                        let item = res.data.options.item;
                        afterSend(item);
                    }
                    else if (res.data.status == 2) {
                        A.err('あなたはこのグループから退出しました。');
                        t.$emit('group-change');
                        t.back();
                    }
                }).catch(err => {
                    msgItem.status = 2;
                });
            }
            else if (t.employee) {
                instance.post('chatMsg/sendToEmployee/' + t.employee.id + '/' + 1, form).then(res => {
                    if (res.data.status == 1) {
                        let item = res.data.options.item;
                        afterSend(item);
                    }
                }).catch(err => {
                    msgItem.status = 2;
                });
            }

        },

        takePhoto() {

        },

        checkNotice() {
            let t = this;
            t.groupId = t.group.id;
            t.groupAction = '';
            t.groupMode = 'notice';
            t.showGroupEditor = true;
        },

        addMember() {
            let t = this;
            t.showGroupMenu = false;
            t.groupId = t.group.id;
            t.groupAction = 'addMember';
            t.groupMode = 'edit';
            t.showGroupEditor = true;
        },

        groupConfig() {
            let t = this;
            t.showGroupMenu = false;
            t.groupId = t.group.id;
            t.groupAction = '';
            t.groupMode = 'edit';
            t.showGroupEditor = true;
        },

        removeGroup() {

            let t = this;

            t.showGroupMenu = false;

            axios.delete('chatGroup/' + t.group.id).then(res => {
                if (res.data.status == 1) {
                    A.toast('グループの解散が完了しました。');
                    t.$emit('group-change');
                    t.back();
                }
            });

        },

        exitGroup() {

            let t = this;

            t.showGroupMenu = false;

            axios.post('chatGroup/exit/' + t.group.id).then(res => {
                if (res.data.status == 1) {
                    A.toast('グループの退出に成功しました。');
                    t.$emit('group-change');
                    t.back();
                }
            });

        },

        groupIsTransfered(employeeId) {
            this.group.employee_id = employeeId;
        },

    },

    data() {
        return {
            previewImages: [],
            showPreview: false,
            previewIndex: 0,
            uploadTasks: [

            ],
            showUploadPopover: false,
            actions: [{ id: 1, text: '撮る' }, { id: 2, text: '写真' }],
            lastScrollTop: 0,
            lastScrollHeight: 0,
            locking: false,
            lastPosition: false,
            dontShowOnce: false,
            showAtList: false,
            showNotice: false,
            groupMode: '',
            groupAction: '',
            showGroupEditor: false,
            groupId: 0,
            uploading: false,
            dontShowPreview: false,
            showGroupMenu: false,
            showTranslatePopover: false,
            ref: null,
            showMsgList: false,
            hasMoreHistory: false,
            translator: {
                lang: 'none'
            },
            dict: {
                lang: {},
                msg: {}
            },
            f: {
                text: '',
                refEmployees: {},
                imgs: [],
            },
            list: {
                member: [],
                msg: [],
                uploadQueue: [],
                lang: [
                    { 'id': 'none', 'text': 'N/A' },
                    { 'id': 'en', 'text': 'ENG' },
                    { 'id': 'cn', 'text': 'CHN' },
                    { 'id': 'jp', 'text': 'JPN' },
                ],
            },
        };
    },
};
